interface PropiedadesLeyendaIlustracion {
    texto?: string;
}

/**
 * Toda ilustración con la paciente de ejemplo lleva esta leyenda: deja claro que los datos
 * que se ven son ficticios y no de un paciente real (UI-SPEC §Color «Shared visual recipes»).
 */
export default function LeyendaIlustracion({ texto = 'Paciente de ejemplo · datos ficticios' }: PropiedadesLeyendaIlustracion) {
    return <p className="m-0 text-[12px] leading-[1.45] text-on-surface-variant">{texto}</p>;
}
